import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CollabCommitDialogModule } from '@portal-core/collab/components/collab-commit-dialog/collab-commit-dialog.module';
import { CommitFileDialogModule } from '@portal-core/commits/components/commit-file-dialog/commit-file-dialog.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { SelfTruncatingPathModule } from '@portal-core/general/components/self-truncating-path/self-truncating-path.module';
import { PreventDefaultModule } from '@portal-core/general/directives/prevent-default/prevent-default.module';
import { FlareCollabEditorModule } from '@portal-core/project-files/components/flare-collab-editor/flare-collab-editor.module';
import { ProjectFlareFileModule } from '@portal-core/project-files/components/project-flare-file/project-flare-file.module';
import { SnackBarErrorModule } from '@portal-core/ui/snack-bar/components/snack-bar-error/snack-bar-error.module';
import { SnackBarWarningModule } from '@portal-core/ui/snack-bar/components/snack-bar-warning/snack-bar-warning.module';
import { WorkspaceFileGitStatusModule } from '@portal-core/workspaces/components/workspace-file-git-status/workspace-file-git-status.module';
import { WorkspaceFileUserStatusListModule } from '@portal-core/workspaces/components/workspace-file-user-status-list/workspace-file-user-status-list.module';
import { WorkspacePullChangesBarModule } from '@portal-core/workspaces/components/workspace-pull-changes-bar/workspace-pull-changes-bar.module';
import { ProjectFilesEditSnippetDialogComponent } from './project-files-edit-snippet-dialog.component';

@NgModule({
  declarations: [
    ProjectFilesEditSnippetDialogComponent
  ],
  imports: [
    CollabCommitDialogModule,
    CommitFileDialogModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    FlareCollabEditorModule,
    LoaderModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatSnackBarModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    PreventDefaultModule,
    ProjectFlareFileModule,
    SelfTruncatingPathModule,
    SnackBarWarningModule,
    SnackBarErrorModule,
    WorkspaceFileGitStatusModule,
    WorkspaceFileUserStatusListModule,
    WorkspacePullChangesBarModule
  ],
  exports: [
    ProjectFilesEditSnippetDialogComponent
  ]
})
export class ProjectFilesEditSnippetDialogModule { }
